$.fn.StickyImages = function(offset = 0) {
  let self = this
  let initialized = false

  self.init = function() {
    if (!$.mlmi.mobile.isMobile && initialized == false) {
      var images = $('<div class="sticky_images"></div>');

      self.find('.grid__item').each(function(i) {
        $(this).attr('data-id', i);
        $(this).find('.card-sticky-image__image').attr('data-id', i);
        images.append($(this).find('.card-sticky-image__image').clone());
      })

      self.append(images);
      initialized = true;
    }
  }

  self.adjustWidth = function() {
    self.init();
    if (!$.mlmi.mobile.isMobile) {
      self.css('--image-width', self.find('.card-sticky-image__image').eq(0).width() + 'px')
    }
  }

  self.init();

  let scrollEvents = $(window).ScrollEvents()
  scrollEvents.add(function(top) {
    var count = self.find('.grid__item .card-sticky-image__image').length
    self.find('.grid__item .card-sticky-image__image').each(function(i) {
      if (testInView($(this))) {
        self.find('.sticky_images .card-sticky-image__image[data-id="' + i + '"]').addClass('--visible')
      } else {
        self.find('.sticky_images .card-sticky-image__image[data-id=' + i + ']').removeClass('--visible')
      }
      if (testInMiddle($(this))) {
        if (i == 0) {
          self.addClass('--fixed')
        }
        if (i+1 == count) {
          self.addClass('--passed')
        }
      } else {
        if (i == 0) {
          self.removeClass('--fixed')
        }
        if (i+1 == count) {
          self.removeClass('--passed')
        }
      }
    })
  })

  function testInMiddle($el){
    var target = $el.offset().top - ($(window).height() / 2) + ($el.height() / 2);
    return $(window).scrollTop() >= target;
  }

  function testInView($el){
    var target = $el.offset().top - ($(window).height() / 2);
    return $(window).scrollTop() >= target;
  }

  return function() {
    $(window).on('resize orientationchange load', self.adjustWidth)
    return self
  }()
};
